export default "__VITE_ASSET__Bbluga09__"